<template>
  <div class="header text-center">
    <img :src="regularImg" style="max-width: 905px; width: 100%;" />
    <h1>
      <strong
        >CALM<br />
        C</strong
      >ompliance <strong>A</strong>nd <strong>L</strong>iability<strong>
        M</strong
      >anagement <br /><strong>System</strong>
    </h1>
    <p style="font-size:1.5rem">Helping to ensure that:</p>
    <ul style="list-style-type: none">
      <li>Lifts are maintained and examined at requisite intervals</li>
      <li>Documentation and records are up to date</li>
      <li>Satisfy your <strong>legal</strong> obligations</li>
    </ul>
    <md-button class="md-primary" @click="goToDashbaord"
      ><md-icon>bar_chart</md-icon> Go to the Dashboard</md-button
    >
  </div>
</template>

<script>
export default {
  props: {
    regularImg: {
      type: String,
      default: "./img/logo.png"
    }
  },
  methods: {
    goToDashbaord() {
      this.$router.push({
        name: "Dashboard"
      });
    }
  }
};
</script>

<style></style>
